<template>
  <span class="priority-tag" v-if="show">
    <i :class="symbol">
      <em v-for="bullet in max" :class="{ on: colorize(bullet) }">&bullet;</em>
    </i>
    <span class="text">{{ tag }}</span>
  </span>
</template>

<script>

const priority = [
  undefined,
  'Standard',
  'Rush',
  'Immediate'
]

export default {
  props: {
    value: [String, Number],
    max: {
      type: Number,
      default: 3
    }
  },
  created() {
    this.value = this.params ? this.params.value : this.value
  },
  computed: {
    show() {
      return this.params ? !this.params.node.rowPinned : true
    },
    tag() {
      return this.value
    },
    priorityNo() {
      let index = priority.indexOf(this.tag)
      // discounted payment terms case
      // will have the same icon as for Rush status
      if (index === -1) index = priority.indexOf('Rush')
      return index
    },
    symbol() {
      return `priority-${this.priorityNo}`
    }
  },
  methods: {
    colorize(i) {
      return i > this.max - this.priorityNo
    }
  }
}

</script>

<style lang='scss'>

.priority-tag {
  white-space: normal;
  i {
    font-style: normal;
    font-size: 17.35px;
    display: inline-block;
    width: 0.4em;
    line-height: 0.38em;
    vertical-align: top;
  }
  em {
    font-style: normal;
    display: inline-block;
    color: #ECECEC;
  }
  .priority {
    &-0 {
      color: #ECECEC;
    }
    &-1 .on {
      color: #75A628;
    }
    &-2 .on {
      color: #FF925E;
    }
    &-3 .on {
      color: #E02630;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/components/PaymentPriorityTag.vue